import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import Benefits from '@/components/Benefits';
import DayForce101 from '@/components/DayForce101';
import Videos401k from '@/components/Videos401k';
import Login from '@/components/Login';
import Cookie from '@/components/Cookie';

import AddMedia from '@/components/backend/gallery/AddMedia';
import ListMedia from '@/components/backend/gallery/ListMedia';
import AddVideos from '@/components/backend/gallery/AddVideos';
import ListVideos from '@/components/backend/gallery/ListVideos';
import PlayVideos from '@/components/backend/gallery/PlayVideos';
import ImageListForApproval from '@/components/backend/gallery/ImageListForApproval';

import HrCalendar from '@/components/hrCalendar';
import EmployeePerksProgram from '@/components/EmployeePerksProgram';
import EmployeeRecognition from '@/components/EmployeeRecognition';
import FormsPolicies from '@/components/FormsPolicies';
import Gallery from '@/components/Gallery';
import LeadershipDevelopment from '@/components/LeadershipDevelopment';
import MeetHRTeam from '@/components/MeetHRTeam';
import Wellness from '@/components/Wellness';
import Plan401k from '@/components/Plan401k';
import Register from '@/components/Register';
import ForgotPassword from '@/components/ForgotPassword';
import ResetPassword from '@/components/ResetPassword';
import Demo from '@/components/backend/Demo';
import Surveys from '@/components/Surveys';
import ERG from '@/components/ERG';
import AddPhoto from '@/components/AddPhoto';
import Forms from '@/components/Forms';
import OurStories from '@/components/OurStories';

import ListBenefits from '@/components/backend/benefits/ListBenefits';
import ListDraggableBenefits from '@/components/backend/benefits/ListDraggableBenefits';

import ListBenefitSupports from '@/components/backend/benefits/ListBenefitSupports';
import ListBenefitCommunications from '@/components/backend/benefits/ListBenefitCommunications';
import ListBenefitTypes from '@/components/backend/benefits/ListBenefitTypes';
import ListBenefitProviders from '@/components/backend/benefits/ListBenefitProviders';
import ListBenefitVideos from '@/components/backend/benefits/ListBenefitVideos';
import ListBenefitSite from '@/components/backend/benefits/ListBenefitSite';
import AddBenefits from '@/components/backend/benefits/AddBenefits';
import AddBenefitSupports from '@/components/backend/benefits/AddBenefitSupports';
import AddBenefitCommunications from '@/components/backend/benefits/AddBenefitCommunications';
import AddBenefitVideo from '@/components/backend/benefits/AddBenefitVideo';
import AddBenefitGlance from '@/components/backend/benefits/AddBenefitGlance';
import ListBenefitGlance from '@/components/backend/benefits/ListBenefitGlance';
import AddBenefitProvider from '@/components/backend/benefits/AddBenefitProvider';
import AddBenefitType from '@/components/backend/benefits/AddBenefitType';
import AddBenefitSite from '@/components/backend/benefits/AddBenefitSite';
import AddEvent from '@/components/backend/events/AddEvent';
import ListEvent from '@/components/backend/events/ListEvent';
import AddNotRegisteredUser from '@/components/backend/notregisteredusers/AddNotRegisteredUser';
import ListNotRegisteredUser from '@/components/backend/notregisteredusers/ListNotRegisteredUser';

import ChangeProfile from '@/components/backend/user/ChangeProfile';
import AddUpdateUsers from '@/components/backend/user/AddUpdateUsers';

import AddDiscount from '@/components/backend/employeeperks/AddDiscount';
import ListDiscount from '@/components/backend/employeeperks/ListDiscount';
import ListUser from '@/components/backend/user/ListUser';
import ListNotification from '@/components/backend/user/ListUserNotification';
import ViewNotification from '@/components/backend/user/ViewNotification';
import AddHrTeam from '@/components/backend/meethrteam/AddHrTeam';

import ListCategory from '@/components/backend/category/ListCategory';
import AddCategory from '@/components/backend/category/AddCategory';

import AddLeadershipDevelopment from '@/components/backend/leadershipdevelopment/AddLeadershipDevelopment';
import ListLeadershipDevelopment from '@/components/backend/leadershipdevelopment/ListLeadershipDevelopment';
import ListLeadershipMedia from '@/components/backend/leadershipdevelopment/ListLeadershipMedia';

import AddDayforce101 from '@/components/backend/dayforce101/AddDayforce101';
import ListDayforce101 from '@/components/backend/dayforce101/ListDayforce101';
import ListDayforce101Media from '@/components/backend/dayforce101/ListDayforce101Media';

import Add401kSlider from '@/components/backend/401kslider/Add401kSlider';
import List401kSlider from '@/components/backend/401kslider/List401kSlider';
import ViewUpdate401k from '@/components/backend/401k/ViewUpdate401k';

import Add401kVideos from '@/components/backend/401kvideos/Add401kVideos';
import List401kVideos from '@/components/backend/401kvideos/List401kVideos';

import AddDayforce101Docs from '@/components/backend/dayforce101docs/AddDayforce101Docs';
import ListDayforce101Docs from '@/components/backend/dayforce101docs/ListDayforce101Docs';
import ViewUpdateDayforce101Docs from '@/components/backend/dayforce101docs/ViewUpdateDayforce101Docs';
import BlockListViewDayforceDoc from '@/components/backend/dayforce101docs/BlockListViewDayforceDoc';



/* Wellness */
import AddWellness from '@/components/backend/wellness/AddWellness';
import ListWellness from '@/components/backend/wellness/ListWellness';
import BlockListViewWellness from '@/components/backend/wellness/BlockListViewWellness';
/*WellnessSlider*/
import AddWellnessSlider from '@/components/backend/wellnessslider/AddWellnessSlider';
import ListWellnessSlider from '@/components/backend/wellnessslider/ListWellnessSlider';

/*Policies And Forms  */
import AddPolicesAndForms from '@/components/backend/policiesandforms/AddPolicesAndForms';
import ListPoliciesAndForms from '@/components/backend/policiesandforms/ListPoliciesAndForms';
import BlockListViewPoliciesForms from '@/components/backend/policiesandforms/BlockListViewPoliciesForms';
import ViewUpdatePoliciesForms from '@/components/backend/policiesandforms/ViewUpdatePoliciesForms';

import AddSlider from '@/components/backend/slider/AddSlider';
import ListSlider from '@/components/backend/slider/ListSlider';


import AddUpdateVideo from '@/components/backend/videomaster/AddUpdateVideo';
import ListVideo from '@/components/backend/videomaster/ListVideo';

import AddSurveys from '@/components/backend/surveys/AddSurveys';
import AddERG from '@/components/backend/ERGs/AddERG';
import ListSurveys from '@/components/backend/surveys/ListSurveys';
import ListERGs from '@/components/backend/ERGs/ListERGs';
import ViewUpdateSurveys from '@/components/backend/surveys/ViewUpdateSurveys';
import ViewUpdateERG from '@/components/backend/ERGs/ViewUpdateERG';
import BlockListViewSurveys from '@/components/backend/surveys/BlockListViewSurveys';

import HRDragView from '@/components/backend/user/HRDragView';

import AddUpdateFAQ from '@/components/backend/faq/AddUpdateFAQ';
import DraggableListFAQ from '@/components/backend/faq/DraggableListFAQ';
import NineBox from '@/components/backend/9box/9Box';
import ListTalentProfile from '@/components/backend/talentprofile/ListTalentProfile';
import TalentProfile from '@/components/backend/talentprofile/TalentProfile';
import FAQ from '@/components/FAQ';

/* Social Media Calendar start*/
import ListSocialEvent from '@/components/backend/socialmediacalendar/ListSocialEvent';
import AddSocialMediaEntry from '@/components/backend/socialmediacalendar/AddSocialEvent';
import SocialMediaCalendar from '@/components/SocialMediaCalendar';
import ERGCalendar from '@/components/ERGCalendar';
/* Social Media Calendar end*/
/* VVG Contact Extension Directory start*/
import LocationListContact from '@/components/backend/contactextension/LocationListContact';
import LocationList from '@/components/backend/ManageLocation/LocationList';
import CompanyList from '@/components/backend/ManageCompany/CompanyList';
import AddCompany from '@/components/backend/ManageCompany/AddCompany';
import DepartmentsList from '@/components/backend/ManageDepartments/DepartmentsList';
import DepartmentListContact from '@/components/backend/contactextension/DepartmentListContact';
import ListContact from '@/components/backend/contactextension/ListContact';
import EditLocationContact from '@/components/backend/contactextension/EditLocationContact';
import EditDepartmentContact from '@/components/backend/contactextension/EditDepartmentContact';
import AddContact from '@/components/backend/contactextension/AddContact';
import AddLocation from '@/components/backend/ManageLocation/AddLocation';
import AddDepartment from '@/components/backend/ManageDepartments/AddDepartments';
import ViewLocationDepartments from '@/components/backend/contactextension/ViewLocationDepartments';
import ViewContactList from '@/components/backend/contactextension/ViewContactList';
import SearchUserData from '@/components/backend/contactextension/SearchUserData';
import PrintContactList from '@/components/backend/contactextension/print/PrintContactList';
/* VVG Contact Extension Directory end*/

import UpdateContactHR from '@/components/backend/contactHR/UpdateContactHR';
import ListManagerToolBox from '@/components/backend/ManagerToolBox/ListManagerToolBox';
import ListFolder from '@/components/backend/ManagerToolBox/ListFolder';
import AddUpdateManagerToolBox from '@/components/backend/ManagerToolBox/AddUpdateManagerToolBox';
import Contact from '@/components/Contact';
import Forum from '@/components/Forum';
import ForumDetails from '@/components/ForumDetails';
import ListForumQuestions from '@/components/backend/forum/ListForumQuestions';
import ListForumComments from '@/components/backend/forum/ListForumComments';
import ViewQuestionOfForumComment from '@/components/backend/forum/ViewQuestionOfForumComment';
import ListForumQuestionImages from '@/components/backend/forum/ListForumQuestionImages';
import ListArchived from '@/components/backend/archived/ListArchived';
import S3TEST from '@/components/backend/policiesandforms/test';
import ManagerToolBox from '@/components/ManagerToolBox';
import DocumentsManagerToolBox from '@/components/DocumentsManagerToolBox';
import AddUpdateFolder from '@/components/backend/ManagerToolBox/AddUpdateFolder';

/*Social Media Management*/
import SocialAccounts from '@/components/backend/socialmedia/socialAccounts';
import AddAccounts from '@/components/backend/socialmedia/addAccount';
import ViewSocialAccount from '@/components/backend/socialmedia/ViewSocialAccount';
import PostTimeline from '@/components/backend/socialmedia/PostTimeline';
import FailedPost from '@/components/backend/socialmedia/FailedPost';
import FailedPostDetail from '@/components/backend/socialmedia/FailedPostDetail';

import ManagerDirectory from '@/components/ManagerDirectory';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
        },
        {
            path: '/benefits',
            name: 'Benefits',
            component: Benefits,
        },
        {
            path: '/day-force-101',
            name: 'Day Force 101',
            component: DayForce101,
        },
        {
            path: '/videos401k',
            name: 'Videos401k',
            component: Videos401k,
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
        },
        {
            path: '/token',
            name: 'Cookie',
            component: Cookie,
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact,
        },
        {
            path: '/forum',
            name: 'Forum',
            component: Forum,
        },
        {
            path: '/forum/:slug',
            name: 'ForumDetails',
            component: ForumDetails,
        },
        {
            path: '/managertoolbox',
            name: 'ManagerToolBox',
            component: ManagerToolBox,
        },
        {
            path: '/documentsmanagertoolbox/:id',
            name: 'DocumentsManagerToolBox',
            component: DocumentsManagerToolBox,
        },
        {
            path: '/employeeperksprogram',
            name: 'EmployeePerksProgram',
            component: EmployeePerksProgram,
        },
        {
            path: '/employeerecognition',
            name: 'EmployeeRecognition',
            component: EmployeeRecognition,
        },
        {
            path: '/formspolicies',
            name: 'FormsPolicies',
            component: FormsPolicies,
        },
        {
            path: '/gallery',
            name: 'Gallery',
            component: Gallery,
        },
        {
            path: '/leadershipdevelopment',
            name: 'LeadershipDevelopment',
            component: LeadershipDevelopment,
        },
        {
            path: '/meethrteam/:id',
            name: 'MeetHRTeam',
            component: MeetHRTeam,
        },
        {
            path: '/meethrteam',
            name: 'MeetHRTeam',
            component: MeetHRTeam,
        },
        {
            path: '/wellness',
            name: 'Wellness',
            component: Wellness,
        },
        {
            path: '/wellness/:id',
            name: 'Wellness',
            component: Wellness,
        },
        {
            path: '/401kplan',
            name: 'Plan401k',
            component: Plan401k,
        },
        {
            path: '/register',
            name: 'Register',
            component: Register,
        },
        {
            path: '/forgotpassword',
            name: 'ForgotPassword',
            component: ForgotPassword,
        },
        {
            path: '/resetpassword/:token',
            name: 'ResetPassword',
            component: ResetPassword
        },
        {
            path: '/hrcalendar',
            name: 'HrCalendar',
            component: HrCalendar,
        },
        {
            path: '/erg',
            name: 'ERG',
            component: ERG,
        },
        {
            path: '/surveys',
            name: 'Surveys',
            component: Surveys,
        },
        {
            path: '/uploadimages',
            name: 'AddPhoto',
            component: AddPhoto,
        },
        {
            path: '/ourstory',
            name: 'OurStories',
            component: OurStories,
        },
        {
            path: '/demo',
            name: 'Demo',
            component: Demo,
        },
        {
            path: '/faq',
            name: 'FAQ',
            component: FAQ,
        },
        {
            path:'/Forms/:id/:title',
            name:'Forms',
            component:Forms,
        },

        /* BACKEND URLs */
        {
            path: '/backend/forum-posts',
            name: 'ListForumQuestions',
            component: ListForumQuestions,
        },


        //This is commented on 29-12-2023 considering that its not in use
        // and also due to facebook/graph-sdk package is used for php 7.2 but its not upgradable to php 8.1
        // {
        //   path: '/backend/social/listaccount',
        //   name: 'SocialAccounts',
        //   component: SocialAccounts,
        // },
        // {
        //   path: '/backend/social/connect/account',
        //   name: 'AddAccounts',
        //   component: AddAccounts,
        // },
        // {
        //   path: '/backend/social/account',
        //   name: 'ViewSocialAccount',
        //   component: ViewSocialAccount,
        // },
        // {
        //   path: '/backend/social/timeline',
        //   name: 'PostTimeline',
        //   component: PostTimeline,
        // },
        // {
        //   path: '/backend/social/failed',
        //   name: 'FailedPost',
        //   component: FailedPost,
        // },
        // {
        //   path: '/backend/failed/post',
        //   name: 'FailedPostDetail',
        //   component: FailedPostDetail,
        // },




        {
            path: '/backend/forum-comments/:id?',
            name: 'ListForumComments',
            component: ListForumComments,
        },
        {
            path: '/backend/forum-question-image/:id',
            name: 'ListForumQuestionImages',
            component: ListForumQuestionImages,
        },
        {
            path: '/backend/forum-comment-details/:id/:questionId?',
            name: 'ViewQuestionOfForumComment',
            component: ViewQuestionOfForumComment,
        },
        {
            path: '/backend/add/:slug',
            // path: '/backend/addmedia',
            name: 'AddMedia',
            component: AddMedia,
        },
        {
            path: '/backend/listmedia',
            name: 'ListMedia',
            component: ListMedia,
        },
        /* TODO need to verify where it is used*/
        {
            path: '/backend/addvideo',
            name: 'AddVideos',
            component: AddVideos,
        },
        {
            path: '/backend/listvideos',
            name: 'ListVideos',
            component: ListVideos,
        },
        {
            path: '/backend/playvideo/:id',
            name: 'PlayVideos',
            component: PlayVideos,
        },
        {
            path: '/backend/listbenefits',
            name: 'ListBenefits',
            component: ListBenefits,
        },
        {
            path: '/backend/listdraggablebenefits',
            name: 'ListDraggableBenefits',
            component: ListDraggableBenefits,
        },
        {
            path: '/backend/listbenefitsupports',
            name: 'ListBenefitSupports',
            component: ListBenefitSupports,
        },
        {
            path: '/backend/listbenefitcommunications',
            name: 'ListBenefitCommunications',
            component: ListBenefitCommunications,
        },
        {
            path: '/backend/listbenefittypes',
            name: 'ListBenefitTypes',
            component: ListBenefitTypes,
        },
        {
            path: '/backend/listbenefitproviders',
            name: 'ListBenefitProviders',
            component: ListBenefitProviders,
        },
        {
            path: '/backend/listbenefitVideos',
            name: 'ListBenefitVideos',
            component: ListBenefitVideos,
        },
        {
            path: '/backend/addbenefits',
            name: 'AddBenefits',
            component: AddBenefits,
        },
        {
            path: '/backend/addbenefitsupport',
            name: 'AddBenefitSupports',
            component: AddBenefitSupports,
        },
        {
            path: '/backend/addbenefitcommunication',
            name: 'AddBenefitCommunications',
            component: AddBenefitCommunications,
        },
        {
            path: '/backend/addbenefitsvideo',
            name: 'AddBenefitVideo',
            component: AddBenefitVideo,
        },
        {
            path: '/backend/addbenefitglance',
            name: 'AddBenefitGlance',
            component: AddBenefitGlance,
        },
        {
            path: '/backend/updatebenefitglance/:id',
            name: 'UpdateBenefitGlance',
            component: AddBenefitGlance,
        },
        {
            path: '/backend/listbenefitglance',
            name: 'ListBenefitGlance',
            component: ListBenefitGlance,
        },
        {
            path: '/backend/addbenefitsprovider',
            name: 'AddBenefitProvider',
            component: AddBenefitProvider,
        },
        {
            path: '/backend/addbenefitstype',
            name: 'AddBenefitType',
            component: AddBenefitType,
        },
        {
            path: '/backend/updatebenefits/:id',
            name: 'UpdateBenifit',
            component: AddBenefits,
        },
        {
            path: '/backend/updatebenefitsupport/:id',
            name: 'UpdateBenifitSupport',
            component: AddBenefitSupports,
        },
        {
            path: '/backend/updatebenefitcommunication/:id',
            name: 'UpdateBenifitCommunication',
            component: AddBenefitCommunications,
        },
        {
            path: '/backend/updatebenefitsvideo/:id',
            name: 'UpdateBenefitVideo',
            component: AddBenefitVideo,
        },
        {
            path: '/backend/updatebenefitsprovider/:id',
            name: 'UpdateBenefitProvider',
            component: AddBenefitProvider,
        },
        {
            path: '/backend/updatebenefitstype/:id',
            name: 'UpdateBenefitType',
            component: AddBenefitType,
        },
        {
            path: '/backend/addevent',
            name: 'AddEvent',
            component: AddEvent,
        },
        {
            path: '/backend/updateevent/:id',
            name: 'UpdateEvent',
            component: AddEvent,
        },
        {
            path: '/backend/listevent',
            name: 'ListEvent',
            component: ListEvent,
        },
        {
            path: '/backend/addnotregistereduser',
            name: 'AddNotRegisteredUser',
            component: AddNotRegisteredUser,
        },
        {
            path: '/backend/updatenotregistereduser/:id',
            name: 'UpdateNotRegisteredUser',
            component: AddNotRegisteredUser,
        },
        {
            path: '/backend/listnotregistereduser',
            name: 'ListNotRegisteredUser',
            component: ListNotRegisteredUser,
        },
        {
            path: '/backend/changeprofile',
            name: 'ChangeProfile',
            component: ChangeProfile,
        },
        {
            path: '/backend/adddiscount',
            name: 'AddDiscount',
            component: AddDiscount,
        },
        {
            path: '/backend/updatediscount/:id',
            name: 'UpdateDiscount',
            component: AddDiscount,
        },
        {
            path: '/backend/listdiscount',
            name: 'ListDiscount',
            component: ListDiscount,
        },
        {
            path: '/backend/listcategory/:type',
            name: 'ListCategory',
            component: ListCategory,
        },
        {
            path: '/backend/addcategory/:type',
            name: 'AddCategory',
            component: AddCategory,
        },
        {
            path: '/backend/updatecategory/:type/:id',
            name: 'UpdateCategory',
            component: AddCategory,
        },
        {
            path: '/backend/addhrteam',
            name: 'AddHrTeam',
            component: AddHrTeam,
        },
        {
            path: '/backend/updatehrteam/:id',
            name: 'UpdateHrTeam',
            component: AddHrTeam,
        },
        {
            path: '/backend/listusers',
            name: 'ListUser',
            component: ListUser,
        },
        {
            path: '/backend/listnotification',
            name: 'ListNotification',
            component: ListNotification,
        },
        {
            path: '/backend/viewnotification/:id',
            name: 'ViewNotification',
            component: ViewNotification,
        },
        {
            path: '/backend/addleadershipdevelopment',
            name: 'AddLeadershipDevelopment',
            component: AddLeadershipDevelopment,
        },
        {
            path: '/backend/listleadershipdevelopment',
            name: 'ListLeadershipDevelopment',
            component: ListLeadershipDevelopment,
        },
        {
            path: '/backend/updateleadershipdevelopment/:id',
            name: 'UpdateLeadershipDevelopment',
            component: AddLeadershipDevelopment,
        },
        {
            path: '/backend/updateusers/:id',
            name: 'AddUpdateUsers',
            component: AddUpdateUsers,
        },
        {
            path: '/backend/listleadershipmedia',
            name: 'ListLeadershipMedia',
            component: ListLeadershipMedia,
        },
        {
            path: '/backend/addbenefitsite',
            name: 'AddBenefitSite',
            component: AddBenefitSite,
        },
        {
            path: '/backend/updatebenefitsite/:id',
            name: 'UpdateBenefitSite',
            component: AddBenefitSite,
        },
        {
            path: '/backend/listbenefitsite',
            name: 'ListBenefitSite',
            component: ListBenefitSite,
        },
        {
            path: '/backend/adddayforce101',
            name: 'AddDayforce101',
            component: AddDayforce101,
        },
        {
            path: '/backend/listdayforce101',
            name: 'ListDayforce101',
            component: ListDayforce101,
        },
        {
            path: '/backend/updatedayforce101/:id',
            name: 'UpdateDayforce101',
            component: AddDayforce101,
        },
        {
            path: '/backend/listdayforce101media',
            name: 'ListDayforce101Media',
            component: ListDayforce101Media,
        },
        {
            path: '/backend/addwellness',
            name: 'AddWellness',
            component: AddWellness,
        },
        {
            path: '/backend/updatewellness/:id',
            name: 'UpdateWellness',
            component: AddWellness,
        },
        {
            path: '/backend/listwellness',
            name: 'ListWellness',
            component: ListWellness,
        },
        {
            path: '/backend/draggablelistwellness',
            name: 'BlockListViewWellness',
            component: BlockListViewWellness,
        },
        {
            path: '/backend/addwellnessslider',
            name: 'AddWellnessSlider',
            component: AddWellnessSlider,
        },
        {
            path: '/backend/updatewellnessslider/:id',
            name: 'UpdateWellnessSlider',
            component: AddWellnessSlider,
        },
        {
            path: '/backend/listwellnessslider',
            name: 'ListWellnessSlider',
            component: ListWellnessSlider,
        },
        {
            path: '/backend/add401kslider',
            name: 'Add401kSlider',
            component: Add401kSlider,
        },
        {
            path: '/backend/update401kslider/:id',
            name: 'Update401kSlider',
            component: Add401kSlider,
        },
        {
            path: '/backend/list401kslider',
            name: 'List401kSlider',
            component: List401kSlider,
        },
        {
            path: '/backend/viewupdate401k',
            name: 'ViewUpdate401k',
            component: ViewUpdate401k,
        },
        {
            path: '/backend/add401kvideos',
            name: 'Add401kVideos',
            component: Add401kVideos,
        },
        {
            path: '/backend/upadte401kvideos/:id',
            name: 'Update401kVideos',
            component: Add401kVideos,
        },
        {
            path: '/backend/list401kvideos',
            name: 'List401kVideos',
            component: List401kVideos,
        },
        {
            path: '/backend/addpolicesandforms',
            name: 'AddPolicesAndForms',
            component: AddPolicesAndForms,
        },
        {
            path: '/backend/updatepoliciesforms/:id',
            name: 'UpdatePolicesAndForms',
            component: AddPolicesAndForms,
        },
        {
            path: '/backend/listpoliciesforms',
            name: 'ListPoliciesAndForms',
            component: ListPoliciesAndForms,
        },
        {
            path: '/backend/viewupdatepoliciesforms/:id',
            name: 'ViewUpdatePoliciesForms',
            component: ViewUpdatePoliciesForms,
        },
        {
            path: '/backend/blocklistviewpoliciesforms',
            name: 'BlockListViewPoliciesForms',
            component: BlockListViewPoliciesForms,
        },
        {
            path: '/backend/addslider/:type',
            name: 'AddSlider',
            component: AddSlider,
        },
        {
            path: '/backend/updateslider/:type/:id',
            name: 'UpdateSlider',
            component: AddSlider,
        },
        {
            path: '/backend/listslider/:type',
            name: 'ListSlider',
            component: ListSlider,
        },
        {
            path: '/backend/adddayforce101docs',
            name: 'AddDayforce101Docs',
            component: AddDayforce101Docs,
        },
        {
            path: '/backend/updatedayforce101docs/:id',
            name: 'UpdateDayforce101Docs',
            component: AddDayforce101Docs,
        },
        {
            path: '/backend/listdayforce101docs',
            name: 'ListDayforce101Docs',
            component: ListDayforce101Docs,
        },
        {
            path: '/backend/viewupdatedayforce101docs/:id',
            name: 'ViewUpdateDayforce101Docs',
            component: ViewUpdateDayforce101Docs,
        },
        {
            path: '/backend/blocklistviewdayforcedocs',
            name: 'BlockListViewDayforceDoc',
            component: BlockListViewDayforceDoc,
        },
        {
            path: '/backend/imagelistforapproval',
            name: 'ImageListForApproval',
            component: ImageListForApproval,
        },

        {
            path: '/backend/addvideo/:type',
            name: 'AddUpdateVideo',
            component: AddUpdateVideo,
        },
        {
            path: '/backend/updatevideo/:type/:id',
            name: 'UpdateVideo',
            component: AddUpdateVideo,
        },
        {
            path: '/backend/listvideo/:type',
            name: 'ListVideo',
            component: ListVideo,
        },
        {
            path: '/backend/addservey',
            name: 'AddSurveys',
            component: AddSurveys,
        },
        {
            path: '/backend/updatesurvey/:id',
            name: 'UpdateSurveys',
            component: AddSurveys,
        },
        {
            path: '/backend/listsurveys',
            name: 'ListSurveys',
            component: ListSurveys,
        },
        {
            path: '/backend/listerg',
            name: 'ListERGs',
            component: ListERGs,
        },
        {
            path: '/backend/adderg',
            name: 'AddERG',
            component: AddERG,
        },
        {
            path: '/backend/updateerg/:id',
            name: 'UpdateERG',
            component: AddERG,
        },
        {
            path: '/backend/viewupdatesurves/:id',
            name: 'ViewUpdateSurveys',
            component: ViewUpdateSurveys,
        },
        /* Obsolete(As discussed on 12/03/2024)
        {
            path: '/backend/viewupdateerg/:id',
            name: 'ViewUpdateERG',
            component: ViewUpdateERG,
        },*/
        {
            path: '/backend/blocklistviewsurveys',
            name: 'BlockListViewSurveys',
            component: BlockListViewSurveys,
        },
        {
            path: '/backend/hrdragview',
            name: 'HRDragView',
            component: HRDragView,
        },
        {
          path: '/backend/9box',
          name: 'NineBox',
          component: NineBox,
        },
        {
          path: '/backend/list/talentprofile',
          name: 'ListTalentProfile',
          component: ListTalentProfile,
        },
        {
          path: '/backend/talentprofile',
          name: 'TalentProfile',
          component: TalentProfile,
        },
        {
            path: '/backend/draggablefaqlist',
            name: 'DraggableListFAQ',
            component: DraggableListFAQ,
        },
        {
            path: '/backend/addfaq',
            name: 'AddUpdateFAQ',
            component: AddUpdateFAQ,
        },
        {
            path: '/backend/updatefaq/:id',
            name: 'UpdateFAQ',
            component: AddUpdateFAQ,
        },
        {
            path: '/backend/listsocialmediacalendar',
            name: 'ListSocialEvent',
            component: ListSocialEvent,
        },
        {
            path: '/backend/addsocialmediaentry',
            name: 'AddSocialMediaEntry',
            component: AddSocialMediaEntry,
        },
        {
            path: '/backend/updatesocialmediaentry/:id',
            name: 'UpdateSocialMediaEntry',
            component: AddSocialMediaEntry,
        },
        {
            path: '/socialmediacalendar',
            name: 'SocialMediaCalendar',
            component: SocialMediaCalendar,
        },
        {
            path: '/calender/:slug',
            name: 'ERGCalendar',
            component: ERGCalendar,
        },
        {
            path: '/backend/contactextensionlist',
            name: 'ListContact',
            component: ListContact,
        },
        {
            path: '/backend/locationextensionlist',
            name: 'LocationListContact',
            component: LocationListContact,
        },
        {
            path: '/backend/locationlist',
            name: 'LocationList',
            component: LocationList,
        },
        {
            path: '/backend/companylist',
            name: 'CompanyList',
            component: CompanyList,
        },
        {
            path: '/backend/addcompany',
            name: 'AddCompany',
            component: AddCompany,
        },
        {
            path: '/backend/updatecompany/:id',
            name: 'UpdateCompany',
            component: AddCompany,
        },
        {
            path: '/backend/departmentlist',
            name: 'DepartmentsList',
            component: DepartmentsList,
        },
        {
            path: '/backend/departmentextensionlist',
            name: 'DepartmentListContact',
            component: DepartmentListContact,
        },
        {
            path: '/backend/addcontact',
            name: 'AddContact',
            component: AddContact,
        },
        {
            path: '/backend/updatecontact/:id',
            name: 'UpdateContact',
            component: AddContact,
        },
        {
            path: '/backend/addlocation',
            name: 'AddLocation',
            component: AddLocation,
        },
        {
            path: '/backend/updatelocation/:id',
            name: 'UpdateLocation',
            component: AddLocation,
        },
        {
            path: '/backend/adddepartment',
            name: 'AddDepartment',
            component: AddDepartment,
        },
        {
            path: '/backend/updatedepartment/:id',
            name: 'UpdateDepartment',
            component: AddDepartment,
        },
        {
            path: '/backend/updatelocationcontact/:id',
            name: 'UpdateLocationContact',
            component: EditLocationContact,
        },
        {
            path: '/backend/updatedepartmentcontact/:id',
            name: 'UpdateDepartmentContact',
            component: EditDepartmentContact,
        },
        {
            path: '/backend/updatecontacthr',
            name: 'UpdateContactHR',
            component: UpdateContactHR,
        },
        {
            path: '/backend/listarchived',
            name: 'ListArchived',
            component: ListArchived,
        },
        {
            path: '/backend/listmanagertoolbox',
            name: 'ListManagerToolBox',
            component: ListManagerToolBox,
        },
        {
            path: '/backend/listmanagertoolbox/:id',
            name: 'ListManagerToolBoxByID',
            component: ListManagerToolBox,
        },
        {
            path: '/backend/listfolder',
            name: 'ListFolder',
            component: ListFolder,
        },
        {
            path: '/backend/folder/add',
            name: 'AddUpdateFolder',
            component: AddUpdateFolder
        },
        {
            path: '/backend/folder/edit/:id',
            name: 'EditFolder',
            component: AddUpdateFolder
        },
        {
            path: '/backend/addmanagertoolbox',
            name: 'AddManagerToolBox',
            component: AddUpdateManagerToolBox,
        },
        {
            path: '/backend/updatemanagertoolbox/:id',
            name: 'UpdateManagerToolBox',
            component: AddUpdateManagerToolBox,
        },

        /* EXTENSION DIRECTORY URLs */
        {
            path: '/directory/extensions/:slug',
            name: 'ViewLocationDepartments',
            component: ViewLocationDepartments,
        },
        {
            path: '/directory/extensionslist/:company/:location',
            name: 'ViewContactList',
            component: ViewContactList,
        },
        {
            path: '/print/extensionslist/:company/:location',
            name: 'PrintContactList',
            component: PrintContactList,
        },
        {
            path: '/directory/extensionslist/:slug',
            name: 'SearchUserData',
            component: SearchUserData,
        },
        {
            path: '/s3test',
            name: 'S3TEST',
            component: S3TEST,
        },
        {
            path: '/manager/directory',
            name: 'ManagerDirectory',
            component: ManagerDirectory,
        },
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js